import { createFileRoute } from "@tanstack/react-router";
import {
  optionalLiteralParam,
  optionalStringParam,
  parseableSearchSchema,
} from "@crm/effect/schema/search";
import { Schema } from "effect";

const metricsSearchSchema = parseableSearchSchema(
  Schema.Struct({
    month: optionalStringParam(),
    perfTab: optionalLiteralParam("overview", "result", "process", "emotion", "operation"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/")({
  head: () => ({
    meta: [{ title: "教练指标 · imiker CRM" }],
  }),
  validateSearch: metricsSearchSchema,
  pendingMinMs: 200
});
